<template>
  <div class="layout-header">
    <template v-if="token && userinfo">
      <li class="dropdown">
        <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><img class="headicon" v-if="userinfo && userinfo.img" :src="userinfo.img || require('@/assets/img/default-headicon.png')" />{{userinfo.name || userinfo.phone}} <span class="caret"></span></a>
        <ul class="dropdown-menu">
          <li><router-link to="/user/center">个人中心</router-link></li>
          <li><router-link to="/shopping/cart">购物车</router-link></li>
          <li><router-link to="/address/manage">管理地址</router-link></li>
          <li role="separator" class="divider"></li>
          <li><router-link to="/order/center">订单</router-link></li>
          <li role="separator" class="divider"></li>
          <li><a @click="logout()">登出</a></li>
        </ul>
      </li>
      <!-- <a class="loginbtn" href="/login">{{userinfo.phone}}</a> -->
    </template>
    <template v-else>
      <router-link class="loginbtn" to="/login">登录</router-link>
    </template>
    <!-- <a class="loginbtn" @click="showPanel(true)">登录</a>
    <!-- <a>marketing@afcwave.cn</a> -->

    <div class="lo-mask" v-show="panelShow" @click="showPanel(false)"></div>
    <div class="lo-panel" v-show="panelShow">
      <!--=======登录=======-->
      <div v-show="panelSwitch == 0" class="content login">
        <p class="title">账号登录</p>
        <form>
          <p class="lo-label">账号</p>
          <input class="lo-input" placeholder="请输入您的账号" type="text" />
          <p class="lo-label">密码</p>
          <input class="lo-input" placeholder="请输入您的密码" type="password" />

          <div class="item">
            <label class="remember"><input type="checkbox"><span>记住登录</span></label>
          </div>
          <button class="lo-submit" type="button">登录</button>
        </form>
        <div class="switch-wrap">
          <a class="switch" @click="changeSwitch(1)">没有账号？点击注册</a>
          <div class="clear"></div>
        </div>
      </div>

      <!--=======注册=======-->
      <div v-show="panelSwitch == 1" class="content register">
        <p class="title">账号注册</p>
        <form>
          <p class="lo-label">手机号码</p>
          <input class="lo-input" placeholder="请输入手机号码" type="text" />

          <p class="lo-label">手机验证码</p>
          <div class="yzm">
            <input class="lo-input" type="text" placeholder="请输入验证码" /><button type="button">发送验证</button>
            <div class="clear"></div>
          </div>

          <p class="lo-label">密码</p>
          <input class="lo-input" placeholder="请输入您的密码" type="password" />

          <p class="lo-label">确认密码</p>
          <input class="lo-input" placeholder="确认密码" type="password" />

          <button class="lo-submit" type="button">注册</button>
        </form>
        <div class="switch-wrap">
          <a class="switch" @click="changeSwitch(0)">已有账号？点击登录</a>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
export default {
  name: 'LayoutHeader',
  data() {
    return {
      panelShow: false,
      panelSwitch: 0,  //0：登录、1注册
      userinfo: null,
      token: null
    };
  },
  computed: {
    ...mapGetters('user', ['getUserInfo', 'getToken'])
  },
  components: {
  },
  watch: {
    '$route'(v1, v2){
      this.initData();
    }
  },
  methods: {
    ...mapMutations('user', ['MU_Logout']),
    initData(){
      this.userinfo = this.$store.getters['user/getUserInfo'];
      this.token = this.$store.getters['user/getToken'];
    },

    showPanel(val){
      this.panelShow = val;
    },

    changeSwitch(val){
      this.panelSwitch = val;
    },
    logout(){
      this.$store.commit('user/MU_Logout');
    }
  },
  created(){
    this.initData();
  }
};
</script>

<style lang="" scoped>

.layout-header{
  position: fixed;
  top: 0px;
  left: 0px;
  height: 40px;
  width: 100%;
  background-color: #7f0000;
  z-index: 2000;
}

.layout-header>a{
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  color: #FEFEFE;
  font-size: 14px;
  font-weight: 300;
  float: right;
  text-decoration: none;
}
.layout-header .loginbtn{
  margin-right: 30px;
}

.lo-mask{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  z-index: 1500;
}

.lo-panel{
  width: 350px;
  max-height: 98%;
  background-color: #FFF;
  position: fixed;
  left: 50%;
  top: 50%;
  transform:  translate(-50%, -50%);
  box-shadow: 0 0 10px rgba(0,0,0,0.5);
  overflow: hidden; 
  z-index: 2000;
}

.content{
  width: 80%;
  margin: 10px auto;
}

.content .item{
  padding: 10px 0;
}

.content p{
  margin: 0;
  color: #333;
  font-size: 16px;
}

.content .title{
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
  color: #7F0000;
}

.lo-label{
  font-size: 18px;
  color: #666;
  padding: 10px 0;
}

.lo-input{
  display: block;
  width: 100%;
  height: 45px;
  line-height: 45px;
  padding: 5px 10px;
  font-size: 16px;
  color: #000;
  border: 1px solid #CCC;
  border-radius: 5px;
  margin-bottom: 10px;
}

.lo-submit{
  display: block;
  width: 100%;
  height: 45px;
  line-height: 45px;
  background-color: #7F0000;
  color: #FFF;
  text-align: center;
  border: 0;
  border-radius: 5px;
  margin: 5px auto 0px;
  font-size: 16px;
  font-weight: 300;
}

.remember{
  display: inline-block;
  cursor: pointer;
  height: 30px;
}

.remember input{
  display: inline-block;
  float: left;
  width: 14px;
  height: 14px;
  margin: 8px;
}

.remember span{
  color: #333;
  font-size: 14px;
  line-height: 30px;
}

.switch-wrap{
  width: 100%;
  padding: 20px 0 10px;
}

.switch{
  display: inline-block;
  color: #333;
  float: right;
  font-size: 14px;
  cursor: pointer;
}

.yzm .lo-input{
  width: 60%;
  float: left;
}

.yzm button{
  display: block;
  width: 35%;
  float: right;
  height: 45px;
  line-height: 45px;
  background-color: #7F0000;
  color: #FFF;
  text-align: center;
  border: 0;
  border-radius: 5px;
  font-weight: 300;
  font-size: 14px;
}

.register .lo-submit{
  margin-top: 30px;
}

.dropdown{
  float: right;
  height: 40px;
}

.dropdown-toggle{
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  color: #FEFEFE;
  font-size: 14px;
  font-weight: 300;
}

.layout-header >>> .dropdown-menu{
  left: auto;
  right: 10px;
}

.headicon{
  display: inline-block;
  width: 28px;
  height: 28px;
  margin: 6px 0;
  margin-right: 10px;
  border-radius: 100%;
  overflow: hidden;
  background-color: #FFF;
}

@media screen and (max-width: 920px){
  .layout-header .loginbtn{
    margin-right: 10px;
  }
}

@media screen and (max-width: 480px){
  .lo-panel{
    width: 80%; 
    overflow-y: scroll;  
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/LayoutHeader.vue